<div class="row tvs-banner-new tvs-banner-new-tipo-{{srcTipo}} fix_lcp_2">
  <img src="assets/images/website_general/banner-shape-gradient-2.png" class="back_fixed_home futurecast_back" alt="" fetchpriority="high">
  <div class="col-12 tvs-banner-new-col">
    <h1 class="tvs-text-white tvs-text-banner z-20">{{srcTitle}}</h1>

    <img class="m-0 banner-img z-0 banner-img-tipo-{{srcTipo}} d-none d-sm-block" src="{{srcImage}}" alt="" *ngIf="this.srcImage && this.srcImage != ''" fetchpriority="high" />
    <img class="m-0 banner-img z-0 banner-img-tipo-{{srcTipo}} d-block d-sm-none" src="{{srcImageMobile}}" alt="" *ngIf="this.srcImageMobile && this.srcImageMobile != ''" fetchpriority="high" />
  </div>

</div>
